module.exports = __webpack_public_path__ + "static/media/banner-lamoderna.9062d5c5.jpg";